import { OfflineAminoSigner, StdSignature, StdSignDoc, AminoSignResponse } from '@cosmjs/amino';

import { EncodeObject } from '@cosmjs/proto-signing';
import { ParameterChangeProposal } from 'cosmjs-types/cosmos/params/v1beta1/params';
import { TxRaw } from 'cosmjs-types/cosmos/tx/v1beta1/tx';
import { SignDoc } from 'cosmjs-types/cosmos/tx/v1beta1/tx';
import { Chain, Fee, Sender, TxPayload, EIP712ToSign } from '@evmos/transactions';

export type Algo = 'secp256k1' | 'ed25519' | 'sr25519';

export interface AccountData {
  /** A printable address (typically bech32 encoded) */
  readonly address: string;
  readonly algo: Algo;
  readonly pubkey: Uint8Array;
}

export interface DirectSignResponse {
  /**
   * The sign doc that was signed.
   * This may be different from the input signDoc when the signer modifies it as part of the signing process.
   */
  readonly signed: SignDoc;
  readonly signature: StdSignature;
}

export interface OfflineDirectSigner {
  readonly getAccounts: () => Promise<readonly AccountData[]>;
  readonly signDirect: (signerAddress: string, signDoc: SignDoc) => Promise<DirectSignResponse>;
}

export interface OfflineEIP712Signer {
  readonly getAccounts: () => Promise<readonly AccountData[]>;
  readonly signEIP712: (signerAddress: string, signDoc: EIP712ToSign) => Promise<Uint8Array>;
}

export type OfflineSigner = OfflineAminoSigner | OfflineEIP712Signer | OfflineDirectSigner;

export function isOfflineDirectSigner(signer: OfflineSigner): signer is OfflineDirectSigner {
  return (signer as OfflineDirectSigner).signDirect !== undefined;
}

export function isOfflineEIP712Signer(signer: OfflineSigner): signer is OfflineEIP712Signer {
  return (signer as OfflineEIP712Signer).signEIP712 !== undefined;
}

